// extracted by mini-css-extract-plugin
module.exports = {"light":"banzai_light__R45W2","dark":"banzai_dark__oPjQY"};